import { modalOverrides, sponsorModal, textModal } from "./common"

export default [
    {
        width: "5%",
        height: "10%",
        left: "44.1%",
        top: "44%",
        label: "Huawei - Talk With Us",
        modalOverrides: textModal("fit-content"),
        modal: <>
            <h1>The chat feature is now closed.</h1>
            <p>Please contact sponsors using the contact forms.</p>
        </>
    },
    {
        width: "7%",
        height: "15%",
        left: "38.1%",
        top: "63%",
        label: "Huawei - Contact Us",
        onClick: () => {
            document.getElementById("Huawei").click()
        }
    },
    {
        width: "7%",
        height: "15%",
        left: "30.1%",
        top: "63%",
        label: "Huawei - Download PDF",
        target: "_blank",
        isExternal: true,
        href: "https://assets.swoogo.com/uploads/2182202-636a7cea3d60b.pdf"
    },
    {
        width: "7%",
        height: "15%",
        left: "11.1%",
        top: "63%",
        label: "Huawei - Download PDF - Video",
        target: "_blank",
        isExternal: true,
        href: "https://assets.swoogo.com/uploads/2182140-636a780578260.pdf"
    },
    {
        width: "10.4%",
        height: "12%",
        left: "9.1%",
        top: "49%",
        label: "Huawei - Watch Video",
        modalOverrides,
        modal: <div style={{height: "100%", width: "100%"}}>
            <iframe width="100%" height="100%" frameBorder="0"  src="https://player.vimeo.com/video/764623918?h=fc8bcbad22&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen autoplay/>
        </div>
    },
    {
        width: "5.4%",
        height: "11%",
        left: "8.1%",
        top: "17%",
        label: "Huawei - Play Demo",
        modalOverrides,
        modal: <div style={{height: "100%", width: "100%"}}>
            <iframe width="100%" height="100%" frameBorder="0"  src="https://player.vimeo.com/video/769567258?h=ddc2a86447&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen autoplay/>
        </div>
    },
    {
        width: "19.4%",
        height: "11%",
        left: "16.1%",
        top: "22%",
        label: "Huawei - Social Media",
        modalOverrides: textModal(),
        modal: sponsorModal("Booth 2", "Huawei", 
        <>
            Founded in 1987, Huawei is a leading global provider of information and communications technology (ICT) 
            infrastructure and smart devices. We have more than 194,000 employees, and we operate in more than 170 
            countries and regions, serving more than three billion people around the world. Our vision and mission is to bring 
            digital to every person, home and organisation for a fully connected, intelligent world. To this end, we will drive 
            ubiquitous connectivity and promote equal access to networks; bring cloud and artificial intelligence to all four 
            corners of the earth to provide superior computing power where you need it, when you need it; build digital 
            platforms to help all industries and organisations become more agile, efficient, and dynamic; redefine user 
            experience with AI, making it more personalized for people in all aspects of their life, whether they’re at home, in 
            the office, or on the go.
        </>, {
            linkedin: "https://www.linkedin.com/company/huawei/@Huawei",
            company: "https://www.huawei.com/"
        })
    },
]